export const workflowSchemaParameters = ($http: HttpApi) => ({
  list: () => $http.$get('/workflow_schema_parameters'),
});
